import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../graphql/GraphQlProvider';

export interface UpdateCreditCardFeeInput {
    data: {
        id: number
        fee: string | null
        type: number
        type_id?: number | null
    }
}

interface CreditCardFee {
    id: number;
    fee: string;
    type: number;
    type_id: number;
}

export const gqlCreditCardFee = `
    id,
    fee,
    type,
    type_id
`;

interface UpdateCreditCardFeeData {
    __typename?: string,
    updateCreditCardFee: CreditCardFee
}

export const UPDATE_CREDIT_CARD_FEE_MUTATION = gql`
    mutation updateCreditCardFee($data: UpdateCreditCardFeeInput!){
        updateCreditCardFee(data: $data){
            ${gqlCreditCardFee}
        }
    }
`;

export const updateCreditCardFee = () => useMutation<UpdateCreditCardFeeData, UpdateCreditCardFeeInput>(
    UPDATE_CREDIT_CARD_FEE_MUTATION,
    {
        update: updateCacheByType('CreditCardFee'),
    }
);

export default updateCreditCardFee;
